import * as tokens from "sushiweb/tokens/color";

/**
 * Resolve a color object returned by backend to a hex string using sushiweb tokens.
 * 
 * @param {Object|string} colorObj
 * @returns {string|null}
 */
function getHexColor(colorObj) {
    if (!colorObj) return null;
    if (typeof colorObj === "string") return colorObj;
    if (colorObj.hexCode) return colorObj.hexCode;

    const type = (colorObj.type || "").toLowerCase();
    const tint = `${colorObj.tint || ""}`; 
    if (!type || !tint) return null;

    const group = tokens[type];
    if (!group) return null;

    const key = `z${parseInt(tint, 10)}`;
    return group[key] || null;
}

export default getHexColor;
